// This file is used to override the frontend styling and placement of the checkpoint form elements
// The code here does not modify any of the checkpoint pluign code

import * as $ from 'jquery';
import { gestaltSimilarity } from '../lib/gestaltSimilarity';
// select checkpoint wrapper element
var checkpointApp = document.getElementById('chkpt-address-lookup-app');

$( document ).ajaxComplete(function(event, xhr, settings) {
    // select form elements
    const checkpointHeading = $('#enter-your-address');
    const checkpointForm = $('#chkpt-address-lookup-form');
    const baseUrl = document.location.origin;
    // check that ajax response is from checkpoint plugin
    if(checkpointApp && settings.url === `${baseUrl}/wp-admin/admin-ajax.php`) {

        // get the response status from the ajax request
        const checkpointResponseStatus = xhr.responseJSON.success;
        // if request is success, adjust the frontend of the form
        if(checkpointResponseStatus) {
            // update heading
            checkpointHeading.text('Select Your Address');
            // create new element with text and link and add to form
            const newElem = $('<p>We service several addresses that are close to the one you entered. Please select your address in the list below, or if it is not listed <a href="/outside-of-service-area/">submit your information here</a>.</p>');
            $('#chkpt-address-lookup-app').prepend(newElem);
            // remove the address inputs
            checkpointForm.css({ display: 'none' });

        } else {
            return;
        }
    } else {
        return;
    }
});

function sortAddresses(selectElement: HTMLSelectElement) {
    // get user house and zip
    const userHouse = (document.getElementById("chkpt-lookup-house-number") as HTMLInputElement).value.toUpperCase();
    // create empty array for sorted options
    const optionsTemp = new Array<{distance: number, element: HTMLOptionElement}>();
    // loop over existing options and sort according to string similarity (using gestalt algorithm)
    while (selectElement.options.length > 0) {
        const optionElement = selectElement.options[0];
        let distance = 0;
        if (optionElement.value === "none") {
            distance = 1000;
        } else {
            distance = gestaltSimilarity(optionElement.innerText.toUpperCase(), userHouse);
            if (distance < 0.33) {
                distance = 0;
            }
         }
        optionsTemp.push({
            distance,
            element: optionElement
        });
        selectElement.options.remove(0);
    }

    optionsTemp.sort((a, b) => {
        const distanceA = a.distance;
        const distanceB = b.distance;
        if (distanceA < distanceB) {
            return 1;
        }
        if (distanceA > distanceB) {
            return -1;
        }
        return 0;
    });
    // add sorted options back to UI
    try {
        for (let i=0; i < optionsTemp.length; i++) {
            selectElement.options.add(optionsTemp[i].element);
        }
    } catch (error) {
        console.log(error);
    }
}

// add mutation observer to checkpoint element
if (checkpointApp !== null) {
    const checkpointSelects = document.documentElement.getElementsByClassName("uk-select");
    const setupStyleClass = "checkpointAddressList--isSorted";

    const onMutation = (mutationRecords: MutationRecord[]) => {
        let isChildListChange = false;
        for (const record of mutationRecords) {
            if (record.type === "childList") {
                isChildListChange = true;
                break;
            }
        }
        if (isChildListChange) {
            for(let i=0; i < checkpointSelects.length; i++) {
                const selectElement = checkpointSelects[i];
                if (selectElement.id == "selectedAddress" && selectElement.classList.contains(setupStyleClass) === false && selectElement instanceof HTMLSelectElement) {
                    sortAddresses(selectElement);
                    selectElement.classList.add(setupStyleClass);
                }
            }
        }
    };

    const observer = new MutationObserver(onMutation);
    observer.observe(document.documentElement, {
        childList: true,
        subtree: true,
        characterData: false,
        attributes: false
    });
}